/**
 * Checks whether the current pathname finishes by '/new'.
  * @private
 * @param  {string} path
 * @returns {boolean}
 */
function isNewRouteUtil (path) {
  if (!path) {
    return false
  }
  return !!path.endsWith('/new')
}

export default isNewRouteUtil
